const Masks = {
  phone: [
    '+',
    '7',
    ' ',
    '(',
    /\d/,
    /\d/,
    /\d/,
    ')',
    ' ',
    /\d/,
    /\d/,
    /\d/,
    '-',
    /\d/,
    /\d/,
    '-',
    /\d/,
    /\d/,
  ],
};

const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
function isValidEmail(email) {
  return emailRegex.test(email);
}

window.addEventListener('DOMContentLoaded', () => {
  const callbackInputEmail = document.getElementById('callback-input-email');
  const callbackInputPhone = document.getElementById('callback-input-phone');
  const callbackSubmitButton = document.getElementById(
    'callback-submit-button',
  );
  const callbackForm = document.getElementById('callback-form');
  const modal = document.getElementById('modal');
  const modalCloseButton = document.getElementById('modal-close');

  if (callbackInputPhone) {
    callbackInputPhone.addEventListener('input', (event) => {
      const inputValue = event.target.value;
      callbackInputPhone.value = formatWithMask({
        text: inputValue,
        mask: Masks.phone,
      }).masked;
    });
  }

  modalCloseButton.addEventListener('click', (e) => {
    modal.classList.add('opacity-0');
    modal.classList.add('invisible');
  });

  async function onSubmit({ phone, email }) {
    const formData = new FormData();

    if (!isValidEmail(email)) {
      return;
    }
    if (phone.length < 18) {
      return;
    }
    if (!phone || !email) {
      return;
    }

    formData.append('email', email);
    formData.append('phone', phone);

    const res = await postData(
      'https://api-site.garantbit.com/v2/landing?type=rsi.academy',
      formData,
    );

    if (res.error) return;

    modal.classList.remove('opacity-0');
    modal.classList.remove('invisible');

    callbackInputPhone.value = '';
    callbackInputEmail.value = '';
  }

  callbackForm?.addEventListener('submit', async (e) => {
    e.preventDefault();
    onSubmit({
      phone: callbackInputPhone.value,
      email: callbackInputEmail.value,
    });
  });

  callbackSubmitButton?.addEventListener('click', async (e) => {
    e.preventDefault();
    onSubmit({
      phone: callbackInputPhone.value,
      email: callbackInputEmail.value,
    });
  });

  preventAllAnchors();
});

function preventAllAnchors() {
  document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
    anchor.addEventListener('click', function (e) {
      const href = this.getAttribute('href');
      if (href === '#') return;

      const targetId = href.substring(1);
      const targetElement = document.getElementById(targetId);

      if (targetElement) {
        e.preventDefault();

        targetElement.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        });

        history.pushState(null, '', href);
      }
    });
  });
}

async function postData(url, data) {
  const response = await fetch(url, {
    method: 'POST',
    body: data,
  });

  return await response.json();
}

function formatWithMask(props) {
  const {
    text,
    mask,
    obfuscationCharacter = '*',
    maskAutoComplete = false,
  } = props;

  // make sure it'll not break with null or undefined inputs
  if (!text) return { masked: '', obfuscated: '', unmasked: '' };

  if (!mask) {
    return {
      masked: text || '',
      obfuscated: text || '',
      unmasked: text || '',
    };
  }

  const maskArray = typeof mask === 'function' ? mask(text) : mask;

  let masked = '';
  let obfuscated = '';
  let unmasked = '';

  let maskCharIndex = 0;
  let valueCharIndex = 0;

  // eslint-disable-next-line no-constant-condition
  while (true) {
    // if mask is ended, break.
    if (maskCharIndex === maskArray.length) {
      break;
    }

    const maskChar = maskArray[maskCharIndex];
    const valueChar = text[valueCharIndex];

    // if value is ended, break.
    if (valueCharIndex === text.length) {
      if (typeof maskChar === 'string' && maskAutoComplete) {
        masked += maskChar;
        obfuscated += maskChar;

        maskCharIndex += 1;
        continue;
      }
      break;
    }

    // value equals mask: add to masked result and advance on both mask and value indexes
    if (maskChar === valueChar) {
      masked += maskChar;
      obfuscated += maskChar;

      valueCharIndex += 1;
      maskCharIndex += 1;
      continue;
    }

    const unmaskedValueChar = text[valueCharIndex];

    // it's a regex maskChar: let's advance on value index and validate the value within the regex
    if (typeof maskChar === 'object') {
      // advance on value index
      valueCharIndex += 1;

      const shouldObsfucateChar = Array.isArray(maskChar);

      const maskCharRegex = Array.isArray(maskChar) ? maskChar[0] : maskChar;

      const matchRegex = new RegExp(maskCharRegex).test(valueChar);

      // value match regex: add to masked and unmasked result and advance on mask index too
      if (matchRegex) {
        masked += valueChar;
        obfuscated += shouldObsfucateChar ? obfuscationCharacter : valueChar;
        unmasked += unmaskedValueChar;

        maskCharIndex += 1;
      }

      continue;
    } else {
      // it's a fixed maskChar: add to maskedResult and advance on mask index
      masked += maskChar;
      obfuscated += maskChar;

      maskCharIndex += 1;
      continue;
    }
  }

  return { masked, obfuscated, unmasked };
}
